/**
 * <related-posts-slider>
 *
 * Activates Swiper only on mobile (< 750px). On desktop the CSS grid takes over
 * and Swiper stays inactive. Mirrors the why-eleo-slider pattern.
 *
 * Mobile: ~1.1 slides per view (peeks the next card), arrows + line pagination.
 */
class RelatedPostsSlider extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;
  #mq = window.matchMedia('(max-width: 749px)');
  #bound = this.#onBreakpoint.bind(this);

  connectedCallback() {
    this.#mq.addEventListener('change', this.#bound);
    this.#onBreakpoint(this.#mq);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this)) {
        this.#swiper?.destroy(true, true);
        this.#swiper = null;
        this.#onBreakpoint(this.#mq);
      }
    });
  }

  disconnectedCallback() {
    this.#mq.removeEventListener('change', this.#bound);
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }

  #onBreakpoint(e) {
    if (e.matches) {
      this.#initSwiper();
    } else {
      this.#swiper?.destroy(true, true);
      this.#swiper = null;
    }
  }

  #initSwiper() {
    if (this.#swiper) return;

    const init = () => {
      const swiperEl = this.querySelector('.related-posts__swiper');
      if (!swiperEl) return;

      swiperEl.querySelectorAll(':scope .swiper-wrapper > .related-posts__item').forEach((el) => {
        el.classList.add('swiper-slide');
      });

      const prevBtn = this.querySelector('.related-posts__btn--prev');
      const nextBtn = this.querySelector('.related-posts__btn--next');
      const pagination = this.querySelector('.related-posts__pagination');

      this.#swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        a11y: false,
        watchOverflow: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'swiper-button-disabled',
        },
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets',
        },
      });
    };

    if (typeof Swiper !== 'undefined') {
      init();
    } else {
      const swiperScript = document.querySelector('script[src*="swiper-bundle"]');
      if (swiperScript) {
        swiperScript.addEventListener('load', init, { once: true });
      }
    }
  }
}

customElements.define('related-posts-slider', RelatedPostsSlider);
